import React, { useState } from 'react'
import { changePassword } from 'services/user'
import FormCompleted from 'components/FormCompleted'
import ServerError from 'steps/shared/ServerError'
import { useForm } from 'react-hook-form'
import { useYupValidationResolver } from 'hooks/useYupValidationResolver'
import { FormBuilder } from 'components/FormBuilder'
import { generateDynamicYupSchema } from 'components/FormBuilder/generateYupSchemaFromJson'

import CircularProgress from '@mui/material/CircularProgress'
import changePasswordFormJson from './changePasswordForm.json'

import * as styles from './ChangePasswordForm.module.scss'

const ChangePasswordForm = () => {
  const jsonValidationYup = generateDynamicYupSchema(
    changePasswordFormJson.fields,
  )

  const [loading, setLoading] = useState(false)
  const [serverError, setServerError] = useState([])
  const [formSuccessState, setFormSuccessState] = useState(false)

  const formatServerError = obj => {
    let reason =
      'Server could not change password. Check your bew password if they match.'
    if (obj.detail) {
      reason = obj.detail
    }
    return reason
  }

  const handleChangePassword = (
    oldPassword,
    newPassword,
    newPasswordConfirm,
  ) => {
    setLoading(true)
    changePassword(oldPassword, newPassword, newPasswordConfirm)
      .then(result => {
        if (result.success === true) {
          setFormSuccessState(true)
        } else {
          setServerError(formatServerError(result))
        }
      })
      .catch(e => {
        setServerError(formatServerError(e))
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const form = useForm({
    mode: 'onChange',
    defaultValues: {},
    resolver: useYupValidationResolver(jsonValidationYup),
  })

  const { handleSubmit, register } = form

  const onSubmit = values => {
    handleChangePassword(
      values.oldPassword,
      values.newPassword,
      values.newPasswordConfirm,
    )
  }

  return (
    <FormCompleted
      name="checkmark"
      successText="Your password has been successfully changed!"
      isActive={formSuccessState}
    >
      <div className={styles.formContainer}>
        <FormBuilder
          form={form}
          onSubmit={handleSubmit(onSubmit)}
          register={register}
          fields={changePasswordFormJson.fields}
        >
          <div
            style={{
              display: 'flex',
              height: '100%',

              justifyContent: 'end',
              flexDirection: 'column',
              alignItems: 'end',
            }}
          >
            <button
              style={{ minWidth: '180px', maxHeight: '44px' }}
              type="submit"
              className="btn"
            >
              {loading ? (
                <CircularProgress color="white" size={18} />
              ) : (
                'Change password'
              )}
            </button>
          </div>
        </FormBuilder>
        {serverError.length > 0 && (
          <ServerError
            style={{
              marginTop: '20px',
              maxWidth: '320px',
              textAlign: 'center',
            }}
            customMessage={`Server error: ${serverError}`}
          />
        )}
      </div>
    </FormCompleted>
  )
}

export default ChangePasswordForm
